"use strict";

var _storage = require("./storage");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function getAssetFromLocalStorage(a) {
  return (0, _storage.getLocalStorage)()[a];
}

var _default = getAssetFromLocalStorage;
exports["default"] = _default;